import React, { FC } from 'react';

import { DialogBody, Typography } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { Link } from '@material-ui/core';
import { links } from '@api/services/dictionaries/links';
import { useSecurity } from '@api/services/hooks/useSecurity';

const WrongFileModal: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const { isReseller } = useSecurity();
    return (
        <DialogBody variant="alert">
            {t('filedoesnotcontainemail')}
            {!isReseller && (
                <Typography variant="body1" style={{ marginTop: 12 }}>
                    {t('findoutmoreaboutuploadingfiles')}
                    <Link href={links.contactUpload} rel="noreferrer" target="_blank">
                        {t('here')}.
                    </Link>
                </Typography>
            )}
        </DialogBody>
    );
};

export default WrongFileModal;
